export default __webpack_public_path__ + "static/media/tutorial4-2.58d95b17.png";